import { StyleSheet } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  stepTitle: {
    fontSize: Fonts.size.h4,
    marginVertical: 15,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  },
  stepDesc: theme => ({
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
  }),
  searchContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 60,
    alignItems: 'center',
    marginTop: 20,
  },
  searchInput: {
    width: '85%',
    marginHorizontal: 0,
  },
  searchIcon: (isActive) => {
    return {
      backgroundColor: isActive ? Colors.vfRed : Colors.lightGrey,
      width: '15%',
      height: 55,
      alignItems: 'center',
      justifyContent: 'center',
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      marginTop: 6,
      left: -5
    }
  },
  radioGroupContainer: {
    marginVertical: 20,
  },
  continueButton: {
    marginBottom: 60,
  },
  inputText: theme => ({
    color: theme.colors.textColorTwo,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6,
  }),
  line: theme => ({
    height: 55,
    width: 1,
    backgroundColor: theme.colors.textInput.default.baseColor,
    left: -5,
    top: 3,
  })
})

export default styles

